export enum Pathname {
  Board = '/b',
  BoardByBoardId = '/b/[boardId]',
  Library = '/l',
  LibraryGeneral = '/l/general',
  LibraryByLibraryId = '/l/[libraryId]',
  Root = '/',
  /**
   * @deprecated - Saved filter has been renamed to saved search
   */
  SavedFilter = '/saved-filter',
  /**
   * @deprecated - Saved filter has been renamed to saved search
   */
  SavedFilterBySavedFilterId = '/saved-filter/[savedFilterId]',
  SavedSearch = '/saved-search',
  SavedSearchBySavedSearchId = '/saved-search/[savedSearchId]',
  Search = '/all',
}
